<template>
  <AuthBox>
    <h1 class="auth-title">Create account DinoTrack</h1>
    <div class="auth-subtitle mb-6">Please enter following data to create an account</div>
    <form @submit.prevent="submit" style="overflow-y: scroll">
      <div class="py-8">
        <div class="app-section-title">
          {{ $t('content.personal_information') }}
        </div>
        <form-group :name="$t('form.first_name')" :validator="$v.form.firstName">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.firstName"
              v-bind="attrs"
              :label="$t('form.first_name')"
              @input="$v.form.firstName.$touch()"
              @blur="$v.form.firstName.$touch()"
            />
          </template>
        </form-group>
        <form-group name="Last Name" :validator="$v.form.lastName">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.lastName"
              v-bind="attrs"
              label="Last Name"
              @input="$v.form.lastName.$touch()"
              @blur="$v.form.lastName.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.gender')" :validator="$v.form.gender">
          <template slot-scope="{ attrs }">
            <v-select :items="gender" :label="$t('form.gender')" v-bind="attrs" v-model="form.gender">
              <template #item="{item}">
                {{ $t(item.text) }}
              </template>
              <template #selection="{item}">
                {{ $t(item.text) }}
              </template>
            </v-select>
          </template>
        </form-group>
        <form-group :name="$t('form.place_of_birth')" :validator="$v.form.placeOfBirth">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.placeOfBirth"
              v-bind="attrs"
              :label="$t('form.place_of_birth')"
              @input="$v.form.placeOfBirth.$touch()"
              @blur="$v.form.placeOfBirth.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.date_of_birth')" :validator="$v.form.dateOfBirth">
          <template slot-scope="{ attrs }">
            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              :return-value.sync="menuFrom"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template #activator="{ on, attrs:attrActivator }">
                <v-text-field v-model="form.dateOfBirth" :label="$t('form.date_of_birth')" readonly v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                  <template #append>
                    <svg-icon icon="calendar" class="primary--text mr-3" />
                  </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="form.dateOfBirth" :max="datemaxcurrent" :locale="$i18n.locale">
                <v-spacer />
                <v-btn text color="primary" @click="menuFrom = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="primary" @click="$refs.menuFrom.save(form.dateOfBirth)">{{ $t('ok') }}</v-btn>
              </v-date-picker>
            </v-menu>
          </template>
        </form-group>
        <form-group :name="$t('form.email')" :validator="$v.form.email">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.email"
              v-bind="attrs"
              :label="$t('form.email')"
              @input="$v.form.email.$touch()"
              @blur="$v.form.email.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.phone_number')" :validator="$v.form.phoneNumber">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.phoneNumber"
              v-bind="attrs"
              v-phone
              :label="$t('form.phone_number')"
              @input="$v.form.phoneNumber.$touch()"
              @blur="$v.form.phoneNumber.$touch()"
            />
          </template>
        </form-group>

        <div class="app-section-title">{{ $t('content.address_information') }}</div>
        <form-group :name="$t('form.address')" :validator="$v.form.address">
          <template slot-scope="{ attrs }">
            <v-textarea
              v-model="form.address"
              v-bind="attrs"
              :label="$t('form.address')"
              @input="$v.form.address.$touch()"
              @blur="$v.form.address.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
          <template slot-scope="{ attrs }">
            <v-autocomplete
              :items="provinces"
              :loading="loadingProvinces"
              :label="$t('province')"
              item-value="provinceId"
              item-text="name"
              v-bind="attrs"
              v-model="form.provinceId"
              @change="getCities"
              @input="$v.form.provinceId.$touch()"
              @blur="$v.form.provinceId.$touch()"
            />
          </template>
        </form-group>
        <form-group :name="$t('form.city')" :validator="$v.form.cityId">
          <template slot-scope="{ attrs }">
            <v-autocomplete
              :items="cities"
              :loading="loadingCities"
              :label="$t('city')"
              item-value="cityId"
              item-text="name"
              v-bind="attrs"
              v-model="form.cityId"
              @change="getEducation"
              @input="$v.form.cityId.$touch()"
              @blur="$v.form.cityId.$touch()"
            />
          </template>
        </form-group>
        <form-group name="Postal Code" :validator="$v.form.postalCode">
          <template slot-scope="{ attrs }">
            <v-text-field
              minlength="5"
              maxlength="5"
              v-model.number="form.postalCode"
              v-bind="attrs"
              v-number
              label="Postal Code"
              @input="$v.form.postalCode.$touch()"
              @blur="$v.form.postalCode.$touch()"
            />
          </template>
        </form-group>
        <div class="app-section-title">{{ $t('content.school_information') }}</div>
        <form-group :name="$t('form.school_name')" :validator="$v.form.masterSchoolId">
          <template slot-scope="{ attrs }">
            <v-autocomplete
              :items="schoolList"
              :loading="loadingSchool"
              :label="$t('form.school_name')"
              item-value="masterSchoolId"
              item-text="schoolName"
              v-bind="attrs"
              v-model="form.masterSchoolId"
              @input="$v.form.masterSchoolId.$touch()"
              @blur="$v.form.masterSchoolId.$touch()"
            />
          </template>
        </form-group>
        <div v-if="form.masterSchoolId === null">
          <form-group :name="$t('content.manual_input_school')" :validator="$v.form.schoolName">
            <template slot-scope="{ attrs }">
              <v-text-field v-model="form.schoolName" v-bind="attrs" :label="$t('content.manual_input_school')" />
            </template>
          </form-group>
          <form-group :name="$t('content.npsn')">
            <template slot-scope="{ attrs }">
              <v-text-field v-model="form.schoolNumber" v-bind="attrs" :label="$t('content.npsn')" />
            </template>
          </form-group>
        </div>
        <div class="d-flex justify-center">
          <v-btn block color="primary btn-primary-custom mb-6" type="submit" :loading="loading">{{ $t('content.signup') }}</v-btn>
        </div>
      </div>
    </form>
  </AuthBox>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, numeric, maxLength } from 'vuelidate/lib/validators';
import phoneNumber from '@/validators/phoneNumber';
import { alphaSpace } from '@/validators';
import FormGroup from '@/components/base/FormGroup';
import AuthBox from '@/components/base/AuthBox';
import onlyWord from '@/validators/onlyWord';

export default {
  name: 'AuthFormStudentTeacher',
  components: {
    AuthBox,
    FormGroup
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      gender: 'Reference/itemGender',
      provinces: 'Reference/itemProvinces',
      googleAuth: 'Auth/googleAuth'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    siteKey() {
      return process.env.VUE_APP_RECAPTCHA;
    }
  },
  validations: function() {
    return {
      form: {
        firstName: { required, alphaSpace },
        lastName: { alphaSpace },
        schoolName: this.form.masterSchoolId === null ? { required, onlyWord } : {},
        phoneNumber:
          this.type === 'teacher' ? { required, phone: phoneNumber, maxLength: maxLength(15) } : { phone: phoneNumber, maxLength: maxLength(15) },
        email: {
          required,
          email,
          [this.validationName](value) {
            if (!value) return true;
            return new Promise(resolve => {
              this.axios
                .get('api/user/validate-email', {
                  params: {
                    email: value,
                    roleId: 4,
                    userId: this.initialData?.userId || this.$route.params?.id || null
                  }
                })
                .then(() => resolve(true))
                .catch(err => {
                  const code = err?.response?.data?.errorMessages;
                  const errorCode = ['isRegistered', 'isRegisteredInactive', 'isRegisteredInAnotherRole'];
                  this.validationName = errorCode?.[code - 1];
                  resolve(false);
                });
            });
          }
        },
        // email: { required, email },
        gender: { required },
        address: { required, maxAddressLength: maxLength(255) },
        placeOfBirth: { required, alphaSpace },
        dateOfBirth: {
          required,
          date: function(value) {
            return this.datemaxcurrent ? value <= this.datemaxcurrent : true;
          }
        },
        provinceId: { required },
        cityId: { required },
        postalCode: { numeric, maxLength: maxLength(5) },
        masterSchoolId: this.form.masterSchoolId !== null ? { required } : {}
      }
    };
  },
  layout: 'empty',
  data: () => ({
    form: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      gender: '',
      address: '',
      placeOfBirth: '',
      provinceId: null,
      dateOfBirth: '',
      cityId: '',
      postalCode: '',
      schoolId: '',
      used: '',
      masterSchoolId: '',
      educationalLevel: '',
      referalCode: '',
      schoolNumber: '',
      schoolName: ''
    },
    provinceId: '',
    cityId: '',
    educationalLevel: '',
    masterSchoolId: '',
    robot: false,
    loading: false,
    menuFrom: false,
    loadingProvinces: false,
    loadingCities: false,
    loadingEducation: false,
    validationName: 'dynamic',
    loadingSchool: false,
    datemaxcurrent: new Date().toISOString().split('T')[0],
    educationList: [],
    schoolList: []
  }),
  methods: {
    markRecaptchaAsVerified() {
      this.form.robot = true;
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => {
        this.loadingProvinces = false;
        if (this.provinceId) {
          this.form.provinceId = this.provinceId;
          this.getCities();
        }
      });
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
      }
      this.loadingCities = true;
      this.$store
        .dispatch('Reference/fetchCities', this.form.provinceId)
        .then(res => console.info(res))
        .finally(() => {
          this.loadingCities = false;
          if (this.cityId) {
            this.form.cityId = this.cityId;
          }
        });
    },
    getSchool() {
      this.loadingSchool = true;
      this.$store
        .dispatch('School/getSchoolList')
        .then(res => {
          this.schoolList = res;
        })
        .finally(() => {
          this.loadingSchool = false;
          if (this.masterSchoolId) {
            this.form.masterSchoolId = this.masterSchoolId;
          }
        });
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        if (this.form.robot === false) {
          this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.checkbox') });
        }
        return false;
      }
      this.loading = true;
      let role = this.type === 'teacher' ? 4 : 3;
      const payload = { roleId: role, ...this.form };
      this.$store
        .dispatch(`Auth/register`, payload)
        .then(() => {
          this.$router.push({ name: 'AuthRegisterSuccess' });
        })
        .finally(() => (this.loading = false));
    }
  },
  created() {
    if (this.googleAuth) {
      this.form.firstName = this.googleAuth.xV;
      this.form.lastName = this.googleAuth.sT;
      this.form.email = this.googleAuth.pu;
      this.form.registrationToken = this.googleAuth.registrationToken;
    }
    if (this.$route.query.referal_code) {
      this.form.referalCode = this.$route.query.referal_code;
    }
    if (this.$route.query.provinceId) {
      this.provinceId = parseInt(this.$route.query.provinceId);
    }
    if (this.$route.query.cityId) {
      this.cityId = parseInt(this.$route.query.cityId);
    }
    if (this.$route.query.educationalLevel) {
      this.educationalLevel = this.$route.query.educationalLevel;
    }
    if (this.$route.query.masterSchoolId) {
      this.masterSchoolId = this.$route.query.masterSchoolId;
    }
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();
    this.getSchool();
  }
};
</script>

<style lang="scss" scoped>
.dont-have-an-accoun {
  color: #acacac;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.forgot {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.your-role-is-teacher {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
::-webkit-scrollbar {
  width: 1rem;
}

::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 99vmax;
  border: 4px solid #ffff;
}
</style>
